import {RouteDefinition} from '../../../routes';
import {MediaInputListScreen} from './MediaInputListScreen';
import {MediaInputEditScreen} from './MediaInputEditScreen';

export const MediaSettingsRoutes: RouteDefinition[] = [
    {
        routerLink: '/settings/media',
        component: MediaInputListScreen,
    },
    {
        routerLink: '/settings/media/edit/:id',
        component: MediaInputEditScreen,
    },
    {
        routerLink: '/settings/media/edit',
        component: MediaInputEditScreen,
    },
];
